import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// import './QueueItem.scss';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
// import Backdrop from '@material-ui/core/Backdrop';
// import CardHeader from '@material-ui/core/CardHeader';
// import CardMedia from '@material-ui/core/CardMedia';
// import CardContent from '@material-ui/core/CardContent';
// import Collapse from '@material-ui/core/Collapse';
// import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { Avatar } from '@material-ui/core';
// import Paper from '@material-ui/core/Paper';


const getStudentPublicName = student => `${student.firstName} ${student.lastName ? student.lastName[0] : ''}.`;

const QueueItem = ({ meetingData, meetingIndex }) => {
    const listItemBadgeClasses = classNames(
        'tx-student-list__badge',
        'tx-student-list__badge--large',
        {
            'tx-student-list__badge--status--serving': meetingData.status === 'Ready',
        },
    );

    const listItemClasses = classNames(
        'MUI-OVERRIDE-no-box-shadow',
        'grid-x',
        'grid-paddding-y',
        'align-middle',
        'tx-student-list__item',
        {
            'tx-student-list__item--status--serving': meetingData.status === 'Ready',
        },
    );

    /*
        IMPORTANT NOTE: None of the classes in the comments are being read in. I left them there only as a reference for
        what was used in the Angular markup.
    */
    return (
        <Card className={listItemClasses}>
            <CardContent className="cell small-2 large-1">
                <Avatar className="tx-student-list__avatar">
                    <Typography className="tx-student-list__avatar-label">{ meetingIndex + 1 }</Typography>
                </Avatar>
            </CardContent>
            <CardContent className="grid-y cell auto tx-student-list__info">
                <Typography component="h1" className="tx-student-list__title">{ meetingData.student ? getStudentPublicName(meetingData.student) : '' }</Typography>
                <Typography component="h2" className="tx-student-list__subtitle">Advisor: { meetingData.advisorRequested }</Typography>
                <Typography component="h3" className="tx-student-list__meta">{ (new Date(meetingData.createTime)).toDateString() }</Typography>
            </CardContent>
            { meetingData.status === 'Ready' ?
                <CardContent className="grid-x cell auto align-right align-middle tx-student-list__actions">
                    <CardContent className="cell auto align-right">
                        <Typography className={listItemBadgeClasses}>{meetingData.status}</Typography>
                    </CardContent>
                </CardContent>
                : ''
            }
        </Card>
    );
};

export default QueueItem;

QueueItem.propTypes = {
    meetingData: PropTypes.object,
    meetingIndex: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/QueueItem/QueueItemMUI.jsx